// Textos de la zona "audiotest" (test de frecuencias). Claves con prefijo "audiotest.".
// Las partes entre **dobles asteriscos** se pintan en <strong> (ver rich() en AudioTest.js).
const en = {
  'audiotest.cat.subBass': 'Sub-bass',
  'audiotest.cat.bass': 'Bass',
  'audiotest.cat.lowMids': 'Low mids',
  'audiotest.cat.mids': 'Mids',
  'audiotest.cat.voiceMids': 'Vocal mids',
  'audiotest.cat.presence': 'Presence',
  'audiotest.cat.treble': 'Treble',
  'audiotest.cat.air': 'Air',

  'audiotest.graph.bass': 'BASS',
  'audiotest.graph.mids': 'MIDS',
  'audiotest.graph.treble': 'TREBLE',
  'audiotest.graph.footer': 'Frequency (Hz) · top = easy to detect · bottom = needs more volume',

  'audiotest.subtitle.intro': 'Speaker Calibration · Frequency Diagnosis',
  'audiotest.subtitle.testing': 'Frequency {n} of {total} · Calibrating...',
  'audiotest.subtitle.results': 'Diagnosis Complete',

  'audiotest.intro.whatTitle': 'What will you discover?',
  'audiotest.intro.what1': 'How your speakers respond at **11 key frequencies**',
  'audiotest.intro.what2': 'Your personal **frequency perception map**',
  'audiotest.intro.what3': 'The frequencies grouped by **hearing categories**',
  'audiotest.intro.what4': 'Which ranges your device picks up more or less easily',
  'audiotest.intro.howTitle': 'How to take the test',
  'audiotest.intro.how1': 'Set the **volume to 60-70%** before you start',
  'audiotest.intro.how2': 'Use **headphones or external speakers** for better accuracy',
  'audiotest.intro.how3': 'Raise the **fader slowly** until you **barely** hear each tone, and leave it there',
  'audiotest.intro.how4': 'Do it in a **quiet place** for better accuracy',
  'audiotest.intro.start': '🐉 Take a New Test',

  'audiotest.tag.freqs': '11 frequencies',
  'audiotest.tag.time': '~3 minutes',
  'audiotest.tag.fader': 'Volume fader',
  'audiotest.tag.map': 'Perception map',
  'audiotest.tag.categories': 'By category',

  'audiotest.saved.title': 'Your saved tests',
  'audiotest.saved.loadTitle': 'Load this test',
  'audiotest.saved.rename': 'Rename',
  'audiotest.saved.renamePrompt': 'New test name:',
  'audiotest.saved.deleteConfirm': 'Delete this test? This cannot be undone.',

  'audiotest.msg.updated': '✓ Test updated',
  'audiotest.msg.saved': '✓ Test saved',
  'audiotest.msg.loginToSave': '⚠ Sign in to save',
  'audiotest.msg.saveError': '⚠ Could not save',
  'audiotest.msg.loadError': '⚠ Could not load the test',
  'audiotest.msg.renameError': '⚠ Could not rename',
  'audiotest.msg.deleteError': '⚠ Could not delete',

  'audiotest.test.progress': 'Frequency {n} of {total}',
  'audiotest.test.percent': '{p}% complete',
  'audiotest.test.hint': 'Raise the fader until you **barely** start to hear it',
  'audiotest.test.paused': 'Tone paused — resume it if you need to',
  'audiotest.test.pause': '⏸ Pause Tone',
  'audiotest.test.resume': '▶ Resume Tone',
  'audiotest.test.play': '▶ Play Tone',
  'audiotest.test.raise': 'Raise the volume slowly',
  'audiotest.test.playFirst': '▶ Play the tone first',
  'audiotest.test.stopHint': 'Stop right when you start to hear it and leave the fader there',
  'audiotest.test.threshold': 'Threshold set at {v}/100 — move on once it sits at the right spot',
  'audiotest.test.next': 'Next Frequency →',
  'audiotest.test.seeResults': 'See my Results',

  'audiotest.results.title': 'Perception Map',
  'audiotest.results.sub': 'Which ranges your device picks up more or less easily',
  'audiotest.results.byCategory': 'By hearing category',
  'audiotest.results.scale': '◀ harder to detect · easier to detect ▶',

  'audiotest.save.titleUpdate': 'Update this test',
  'audiotest.save.titleNew': 'Save this test',
  'audiotest.save.placeholder': 'Test name (e.g. Living room speakers, Sony headphones...)',
  'audiotest.save.btnUpdate': 'Save changes',
  'audiotest.save.btnNew': 'Save test',
  'audiotest.save.defaultName': 'Untitled test',

  'audiotest.enter': '🐉 Enter Dragon Audio →',
  'audiotest.restart': '↺ Recalibrate',
};

const es = {
  'audiotest.cat.subBass': 'Subgraves',
  'audiotest.cat.bass': 'Graves',
  'audiotest.cat.lowMids': 'Medios graves',
  'audiotest.cat.mids': 'Medios',
  'audiotest.cat.voiceMids': 'Medios para voz',
  'audiotest.cat.presence': 'Presencia',
  'audiotest.cat.treble': 'Agudos',
  'audiotest.cat.air': 'Brillo',

  'audiotest.graph.bass': 'GRAVES',
  'audiotest.graph.mids': 'MEDIOS',
  'audiotest.graph.treble': 'AGUDOS',
  'audiotest.graph.footer': 'Frecuencia (Hz) · arriba = se detecta fácil · abajo = necesita más volumen',

  'audiotest.subtitle.intro': 'Calibración de Parlantes · Diagnóstico de Frecuencias',
  'audiotest.subtitle.testing': 'Frecuencia {n} de {total} · Calibrando...',
  'audiotest.subtitle.results': 'Diagnóstico Completado',

  'audiotest.intro.whatTitle': '¿Qué descubrirás?',
  'audiotest.intro.what1': 'Cómo responden tus parlantes en **11 frecuencias clave**',
  'audiotest.intro.what2': 'Tu **mapa de percepción de frecuencias** personalizado',
  'audiotest.intro.what3': 'Las frecuencias agrupadas por **categorías auditivas**',
  'audiotest.intro.what4': 'Qué rangos detecta tu dispositivo con mayor o menor facilidad',
  'audiotest.intro.howTitle': 'Cómo hacer la prueba',
  'audiotest.intro.how1': 'Ajusta el **volumen al 60-70%** antes de comenzar',
  'audiotest.intro.how2': 'Usa **auriculares o parlantes externos** para mayor precisión',
  'audiotest.intro.how3': 'Sube el **fader lentamente** hasta que **apenas** escuches cada tono y déjalo ahí',
  'audiotest.intro.how4': 'Hazlo en un **lugar tranquilo** para mayor precisión',
  'audiotest.intro.start': '🐉 Hacer un Test Nuevo',

  'audiotest.tag.freqs': '11 frecuencias',
  'audiotest.tag.time': '~3 minutos',
  'audiotest.tag.fader': 'Fader de volumen',
  'audiotest.tag.map': 'Mapa de percepción',
  'audiotest.tag.categories': 'Por categorías',

  'audiotest.saved.title': 'Tus tests guardados',
  'audiotest.saved.loadTitle': 'Cargar este test',
  'audiotest.saved.rename': 'Renombrar',
  'audiotest.saved.renamePrompt': 'Nuevo nombre del test:',
  'audiotest.saved.deleteConfirm': '¿Borrar este test? No se puede deshacer.',

  'audiotest.msg.updated': '✓ Test actualizado',
  'audiotest.msg.saved': '✓ Test guardado',
  'audiotest.msg.loginToSave': '⚠ Inicia sesión para guardar',
  'audiotest.msg.saveError': '⚠ Error al guardar',
  'audiotest.msg.loadError': '⚠ No se pudo cargar el test',
  'audiotest.msg.renameError': '⚠ No se pudo renombrar',
  'audiotest.msg.deleteError': '⚠ No se pudo borrar',

  'audiotest.test.progress': 'Frecuencia {n} de {total}',
  'audiotest.test.percent': '{p}% completado',
  'audiotest.test.hint': 'Sube el fader hasta que **apenas** empieces a oírlo',
  'audiotest.test.paused': 'Tono pausado — reanúdalo si lo necesitas',
  'audiotest.test.pause': '⏸ Pausar Tono',
  'audiotest.test.resume': '▶ Reanudar Tono',
  'audiotest.test.play': '▶ Reproducir Tono',
  'audiotest.test.raise': 'Sube el volumen lentamente',
  'audiotest.test.playFirst': '▶ Primero reproduce el tono',
  'audiotest.test.stopHint': 'Detente justo cuando empieces a oírlo y deja el fader ahí',
  'audiotest.test.threshold': 'Umbral marcado en {v}/100 — avanza cuando lo dejes en el punto justo',
  'audiotest.test.next': 'Siguiente Frecuencia →',
  'audiotest.test.seeResults': 'Ver mis Resultados',

  'audiotest.results.title': 'Mapa de Percepción',
  'audiotest.results.sub': 'Qué rangos detecta tu dispositivo con mayor o menor facilidad',
  'audiotest.results.byCategory': 'Por categoría auditiva',
  'audiotest.results.scale': '◀ menor detección · mayor detección ▶',

  'audiotest.save.titleUpdate': 'Actualizar este test',
  'audiotest.save.titleNew': 'Guardar este test',
  'audiotest.save.placeholder': 'Nombre del test (ej: Parlantes sala, Audífonos Sony...)',
  'audiotest.save.btnUpdate': 'Guardar cambios',
  'audiotest.save.btnNew': 'Guardar test',
  'audiotest.save.defaultName': 'Test sin nombre',

  'audiotest.enter': '🐉 Entrar a Dragon Audio →',
  'audiotest.restart': '↺ Repetir Calibración',
};

const audiotest = { en, es };
export default audiotest;
